import React from "react";

export default function CookiePolicy() {
  const styles = {
    wrap: { maxWidth: 900, margin: "0 auto", padding: "32px 20px", lineHeight: 1.6, color: "#0b1220" },
    h1: { fontSize: 32, marginBottom: 8 },
    small: { color: "#6b7280", fontSize: 14, marginBottom: 24, display: "block" },
    h2: { fontSize: 22, marginTop: 28, marginBottom: 8 },
    h3: { fontSize: 18, marginTop: 22, marginBottom: 8 },
    p: { margin: "10px 0" },
    ul: { margin: "10px 0 10px 18px" },
    li: { margin: "6px 0" },
    note: { background: "#f8fafc", border: "1px solid #e5e7eb", padding: 12, borderRadius: 8, fontSize: 14 },
    tableWrap: { overflowX: "auto", marginTop: 8, marginBottom: 8 },
    table: { borderCollapse: "collapse", width: "100%", minWidth: 640 },
    th: { textAlign: "left", borderBottom: "1px solid #e5e7eb", padding: "10px 8px", fontWeight: 600 },
    td: { borderBottom: "1px solid #f1f5f9", padding: "10px 8px", verticalAlign: "top" },
    code: { background: "#f3f4f6", padding: "2px 6px", borderRadius: 4, fontFamily: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace" },
    hr: { border: 0, borderTop: "1px solid #e5e7eb", margin: "24px 0" },
    nav: { display: "flex", flexWrap: "wrap", gap: 12, margin: "8px 0 16px" },
    navLink: { fontSize: 14, color: "#2563eb", textDecoration: "none" },
  };

  // PERSONALIZZA QUI
  const SITE = {
    name: "Dottoressa Rosa Coppola",
    domain: "www.dottoressarosacoppola.it",
    contactEmail: "info@dottoressarosacoppola.it",
    address: "Corso Giuseppe Garibaldi, 47, 84123 Salerno SA",
    dpoEmail: "", // opzionale
    lastUpdate: "24 settembre 2025",
  };

  return (
    <main style={{ ...styles.wrap, marginTop: 150 }} role="main" aria-labelledby="cookie-title">
      <h1 id="cookie-title" style={styles.h1}>Cookie Policy</h1>
      <small style={styles.small}>Ultimo aggiornamento: {SITE.lastUpdate}</small>

      <div style={styles.note}>
        Questa Cookie Policy descrive come {SITE.name} utilizza cookie e tecnologie affini sul sito <strong>{SITE.domain}</strong>, 
        inclusa l’area blog, i rimandi ai social e il form di contatto.
      </div>

      <nav aria-label="Indice della pagina" style={styles.nav}>
        <a href="#cosa-sono" style={styles.navLink}>1. Cosa sono i cookie</a>
        <a href="#tipi-cookie" style={styles.navLink}>2. Tipi di cookie</a>
        <a href="#cookie-che-usiamo" style={styles.navLink}>3. Cookie che utilizziamo</a>
        <a href="#terze-parti" style={styles.navLink}>4. Cookie di terze parti</a>
        <a href="#gestione-preferenze" style={styles.navLink}>5. Come gestire le preferenze</a>
        <a href="#base-giuridica" style={styles.navLink}>6. Base giuridica e conservazione</a>
        <a href="#modifiche" style={styles.navLink}>7. Modifiche a questa policy</a>
        <a href="#contatti" style={styles.navLink}>8. Contatti</a>
      </nav>

      <section id="cosa-sono">
        <h2 style={styles.h2}>1. Cosa sono i cookie</h2>
        <p style={styles.p}>
          I cookie sono piccoli file di testo che i siti web inviano al dispositivo dell’utente (computer, smartphone, tablet)
          dove vengono memorizzati per essere poi ritrasmessi agli stessi siti alla visita successiva. Servono, ad esempio, a
          far funzionare correttamente il sito, ricordare preferenze e migliorare l’esperienza di navigazione. Tecnologie
          analoghe come pixel, web beacon e local storage possono assolvere funzioni simili.
        </p>
      </section>

      <section id="tipi-cookie">
        <h2 style={styles.h2}>2. Tipi di cookie</h2>
        <h3 style={styles.h3}>2.1 Cookie tecnici (necessari)</h3>
        <p style={styles.p}>
          Sono indispensabili per il funzionamento del sito e non richiedono il consenso dell’utente. Consentono, tra l’altro,
          la navigazione tra le pagine, la gestione della sessione, la sicurezza e l’erogazione dei servizi richiesti
          dall’utente (es. invio del form di contatto).
        </p>

        <h3 style={styles.h3}>2.2 Cookie di preferenza/funzionalità</h3>
        <p style={styles.p}>
          Consentono al sito di ricordare scelte effettuate dall’utente (ad es. lingua) e offrire funzionalità migliorate.
          Possono essere installati solo previo consenso.
        </p>

        <h3 style={styles.h3}>2.3 Cookie statistici/analitici</h3>
        <p style={styles.p}>
          Raccolgono informazioni in forma aggregata sull’uso del sito (pagine visitate, tempo di permanenza, ecc.) per
          migliorarne le prestazioni. Se anonimizzati (ad esempio tramite mascheratura IP e disattivazione di incrocio dati), possono essere assimilati ai tecnici; in caso contrario richiedono consenso.
        </p>

        <h3 style={styles.h3}>2.4 Cookie di profilazione/marketing</h3>
        <p style={styles.p}>
          Sono utilizzati per tracciare la navigazione dell’utente e proporre contenuti e annunci personalizzati, 
          inclusa la misurazione delle campagne. Richiedono sempre il consenso dell’utente.
        </p>
      </section>

      <section id="cookie-che-usiamo">
        <h2 style={styles.h2}>3. Cookie che utilizziamo</h2>
        <p style={styles.p}>
          Di seguito una tabella esemplificativa dei cookie comunemente presenti in un sito vetrina con blog, social e form di contatto.
          L’elenco può variare a seconda delle configurazioni effettive. Aggiorna questa tabella in base ai cookie realmente in uso.
        </p>

        <div style={styles.tableWrap}>
          <table style={styles.table} aria-describedby="cookie-table-desc">
            <caption id="cookie-table-desc" style={{ ...styles.small, textAlign: "left", marginTop: 8 }}>
              Esempio di cookie installati su {SITE.domain}
            </caption>
            <thead>
              <tr>
                <th style={styles.th}>Nome</th>
                <th style={styles.th}>Dominio</th>
                <th style={styles.th}>Tipo</th>
                <th style={styles.th}>Finalità</th>
                <th style={styles.th}>Durata</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={styles.td}><code style={styles.code}>_cookieConsent</code></td>
                <td style={styles.td}>{SITE.domain}</td>
                <td style={styles.td}>Tecnico</td>
                <td style={styles.td}>Memorizza le preferenze di consenso ai cookie.</td>
                <td style={styles.td}>6–12 mesi</td>
              </tr>
              <tr>
                <td style={styles.td}><code style={styles.code}>_session</code></td>
                <td style={styles.td}>{SITE.domain}</td>
                <td style={styles.td}>Tecnico</td>
                <td style={styles.td}>Gestione sessione e sicurezza del sito.</td>
                <td style={styles.td}>Sessione</td>
              </tr>
              <tr>
                <td style={styles.td}><code style={styles.code}>lang_pref</code></td>
                <td style={styles.td}>{SITE.domain}</td>
                <td style={styles.td}>Preferenze</td>
                <td style={styles.td}>Ricorda la lingua selezionata per il blog.</td>
                <td style={styles.td}>6 mesi</td>
              </tr>
              <tr>
                <td style={styles.td}><code style={styles.code}>_ga</code>, <code style={styles.code}>_gid</code></td>
                <td style={styles.td}>.google.com / .{SITE.domain}</td>
                <td style={styles.td}>Analitici</td>
                <td style={styles.td}>Statistiche aggregate sull’uso del sito/blog (Google Analytics).</td>
                <td style={styles.td}>Da sessione a 24 mesi</td>
              </tr>
              <tr>
                <td style={styles.td}><code style={styles.code}>_fbp</code></td>
                <td style={styles.td}>.facebook.com</td>
                <td style={styles.td}>Marketing</td>
                <td style={styles.td}>Misurazione/remarketing tramite Meta Pixel (se implementato).</td>
                <td style={styles.td}>3 mesi</td>
              </tr>
              <tr>
                <td style={styles.td}><code style={styles.code}>__Secure-*</code>, <code style={styles.code}>VISITOR_INFO1_LIVE</code></td>
                <td style={styles.td}>.youtube.com</td>
                <td style={styles.td}>Funzionali/Marketing</td>
                <td style={styles.td}>Riproduzione video incorporati nel blog.</td>
                <td style={styles.td}>Variabile</td>
              </tr>
            </tbody>
          </table>
        </div>

        <p style={styles.p}>
          Il form di contatto può utilizzare cookie tecnici e strumenti antispam (es. reCAPTCHA) che potrebbero impostare cookie
          di terze parti. In tal caso, è necessario informarne l’utente e, se richiesto, acquisire il consenso.
        </p>
      </section>

      <section id="terze-parti">
        <h2 style={styles.h2}>4. Cookie di terze parti e social</h2>
        <p style={styles.p}>
          Alcuni contenuti del sito (es. video incorporati, mappe, pulsanti “segui/mi piace” e link ai profili social) 
          provengono da terze parti che potrebbero impostare cookie propri. L’uso di tali servizi comporta l’invio di 
          dati alla terza parte; per maggiori dettagli si rinvia alle rispettive informative:
        </p>
        <ul style={styles.ul}>
          <li style={styles.li}>Google/YouTube (riproduzione video, statistiche)</li>
          <li style={styles.li}>Meta (Facebook/Instagram) per pulsanti social e misurazione</li>
          <li style={styles.li}>LinkedIn/Twitter(X) per pulsanti social e insight</li>
          <li style={styles.li}>Servizi anti-spam/captcha, mappe, font hosting, CDN</li>
        </ul>
        <p style={styles.p}>
          Quando richiesto dalla normativa, i cookie non tecnici di terze parti vengono installati solo dopo il tuo consenso 
          tramite apposito banner/centro preferenze.
        </p>
      </section>

      <section id="gestione-preferenze">
        <h2 style={styles.h2}>5. Come gestire le preferenze</h2>
        <p style={styles.p}>
          Puoi in qualsiasi momento gestire o revocare il consenso tramite il nostro centro preferenze cookie (se presente)
          oppure intervenendo sulle impostazioni del tuo browser per bloccare/eliminare i cookie. La disattivazione di alcuni
          cookie può influire sul corretto funzionamento del sito.
        </p>
        <h3 style={styles.h3}>Link utili per browser</h3>
        <ul style={styles.ul}>
          <li style={styles.li}>Chrome: <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noreferrer">Impostazioni cookie</a></li>
          <li style={styles.li}>Firefox: <a href="https://support.mozilla.org/it/kb/Eliminare%20i%20cookie" target="_blank" rel="noreferrer">Gestione cookie</a></li>
          <li style={styles.li}>Safari: <a href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" rel="noreferrer">Preferenze privacy</a></li>
          <li style={styles.li}>Edge: <a href="https://support.microsoft.com/it-it/microsoft-edge/eliminare-i-cookie-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noreferrer">Eliminare cookie</a></li>
        </ul>
        <p style={styles.p}>
          Per limitare il tracciamento pubblicitario su dispositivi mobili, consulta le impostazioni del sistema operativo (es. 
          “Limit Ad Tracking” su iOS, “Opt-out annunci personalizzati” su Android).
        </p>
      </section>

      <section id="base-giuridica">
        <h2 style={styles.h2}>6. Base giuridica e tempi di conservazione</h2>
        <p style={styles.p}>
          L’installazione dei cookie tecnici si basa sul legittimo interesse del Titolare a erogare il sito e i suoi servizi. 
          Per cookie non tecnici, la base giuridica è il consenso liberamente prestato dall’utente tramite il banner o 
          il centro preferenze. I cookie hanno una durata variabile indicata nella tabella sopra e comunque non superiore 
          a quanto necessario per le finalità dichiarate.
        </p>
      </section>

      <section id="modifiche">
        <h2 style={styles.h2}>7. Modifiche a questa policy</h2>
        <p style={styles.p}>
          {SITE.name} può aggiornare questa Cookie Policy per adeguamenti normativi o modifiche tecniche del sito.
          Le variazioni saranno pubblicate su questa pagina e, ove opportuno, notificate attraverso il banner di consenso.
        </p>
      </section>

      <section id="contatti">
        <h2 style={styles.h2}>8. Contatti e Titolare del trattamento</h2>
        <p style={styles.p}><strong>Titolare:</strong> {SITE.name}</p>
        <p style={styles.p}><strong>Sede:</strong> {SITE.address}</p>
        <p style={styles.p}><strong>Email privacy:</strong> <a href={`mailto:${SITE.contactEmail}`}>{SITE.contactEmail}</a></p>
        {SITE.dpoEmail ? (
          <p style={styles.p}><strong>Data Protection Officer (DPO):</strong> <a href={`mailto:${SITE.dpoEmail}`}>{SITE.dpoEmail}</a></p>
        ) : null}
        <hr style={styles.hr} />
        <p style={{ ...styles.p, ...styles.note }}>
          Per informazioni su trattamento dati personali, basi giuridiche, diritti degli interessati e contatti, consulta anche la nostra{" "}
          <a href="/privacy-policy">Privacy Policy</a>.
        </p>
      </section>
    </main>
  );
}
